import { selector } from 'recoil'

import { ApiClient } from '../../api'
import { AsyncCacheHandler } from '../../react'
import { $refToken /* , $token */ } from '../auth'

export const $apiClient = selector({
  key: 'API_CLIENT',
  get({ get }) {
    const refToken = get($refToken)

    // Commenting following JWT login due to deprecation in favor of Ref token
    // const jwtToken = get($token)
    // return new ApiClient({ uri: process.env.REACT_APP_API, refToken, jwtToken })

    return new ApiClient({ uri: window.__APP_CONFIG__.API, refToken })
  },
  /**
   * This is very bad! State should be immutable and never be updated but the jwt token may come
   * in a second moment after the state is initialized, this is because the api client is used to
   * make the call to get the jwt token.
   */
  dangerouslyAllowMutability: true,
})

export const $asyncCache = selector({
  key: 'ASYNC_CACHE',
  get() {
    const cache = new AsyncCacheHandler()
    return cache
  },
  dangerouslyAllowMutability: true,
})
